import { css } from 'aphrodite';
import * as React from 'react';
import { AiButton } from '../../../web/components-v2/AiButton';
import { styleSheet } from './styles';

interface IBulkTranscriptDownloadBannerProps {
	onExportClick: () => void;
	onAnalyzeClick: () => void;
	isAnalyzeLoading?: boolean;
}

export const BulkTranscriptDownloadBanner: React.FC<IBulkTranscriptDownloadBannerProps> = ({
	onExportClick,
	onAnalyzeClick,
	isAnalyzeLoading = false,
}) => {
	return (
		<div className={css(styleSheet.banner)}>
			<div className={css(styleSheet.buttonContainer)}>
				<button onClick={onExportClick} className={css(styleSheet.downloadButton)} type='button'>
					Download Meeting Transcripts
				</button>
				<AiButton title='Analyze' onClick={onAnalyzeClick} size='sm' isLoading={isAnalyzeLoading} />
			</div>
		</div>
	);
};
